export const pieceSize=(group,kind)=>Number(group.length_m)*(kind==='sheet'?Number(group.width_m):1);

export function remainingPieces(line,kind,factor,groups,index){
  const kg=['KG','KILOGRAM'].includes((line?.um||'').trim().toUpperCase());
  const physical=Number(line?.quantity)/(kg?Number(factor):1);
  const used=groups.reduce((sum,g,i)=>i===index?sum:sum+Number(g.pieces)*pieceSize(g,kind),0);
  const size=pieceSize(groups[index],kind);
  const count=(physical-used)/size;
  return size>0&&Number.isFinite(count)&&count>0?count:null;
}

export function suggestPieces(line,kind,factor,groups,index){
  const count=remainingPieces(line,kind,factor,groups,index);
  const rounded=count===null?0:Math.round(count);
  const pieces=count!==null&&rounded>0&&rounded<=1000000&&Math.abs(count-rounded)<0.00000001?String(rounded):'';
  return groups.map((group,i)=>i===index?{...group,pieces}:group);
}
